<template>
  <div class="circle-scale">
    <div v-for="index in count" :key="index"
         class="circle-scale-item"
         :class="{active: index <= position}"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      default: 5,
    },
    position: {},
  },
};
</script>

<style lang="scss" scoped>
.circle-scale {
  display: flex;
  justify-content: space-between;
  width: 52px;

  &-item {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #9999A9;
    opacity: 0.35;

    &.active {
      background: #ABC232;
      opacity: 1;
    }
  }
}
</style>
